import "core-js/modules/es.symbol";
import "core-js/modules/es.array.concat";
import "core-js/modules/es.array.filter";
import "core-js/modules/es.object.get-own-property-descriptor";
import "core-js/modules/es.object.keys";
import "core-js/modules/web.dom-collections.for-each";
import "regenerator-runtime/runtime";

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var _marked =
/*#__PURE__*/
regeneratorRuntime.mark(loadAccountCreationConsentForDetectedLocation),
    _marked2 =
/*#__PURE__*/
regeneratorRuntime.mark(loadAccountCreationConsentForSelectedLocation),
    _marked3 =
/*#__PURE__*/
regeneratorRuntime.mark(loadAccountCreationConsent);

import { fetchEntityIfNeeded } from '@classpass/saga-tools';
import { defineMessages } from 'react-intl';
import { all, call, select } from 'redux-saga/effects';
import * as logger from 'universal-logger';
import { deepExtract } from 'helpers/deep';
import { isObject } from 'helpers/verify';
import { selectCountry } from 'redux/modules/locale';
import { cmsLegalContent } from 'redux/saga/entities/bound';
import { getMsa } from 'containers/LocationModal/location.saga';
export var messages = defineMessages({
  accountDisclaimer: {
    id: 'consent-default.account-disclaimer',
    defaultMessage: 'By signing up you agree to our {linkTerms} and verify you have read the {linkPrivacy}.'
  },
  facebookDisclaimer: {
    id: 'consent-default.facebook-disclaimer',
    defaultMessage: 'If you sign up through Facebook, you agree to the {linkTerms} and {linkPrivacy}. If you do not want to receive ClassPass marketing communications, sign up with your email and leave the box above unchecked.'
  },
  marketingDisclaimer: {
    id: 'consent-default.marketing-disclaimer',
    defaultMessage: 'Yes, please send me ClassPass emails with news, offers and other info.'
  },
  searchableDisclaimer: {
    id: 'consent-default.searchable-disclaimer',
    defaultMessage: 'I understand my name will be searchable and that my name, city and photo may be visible to ClassPass members. I can change my privacy settings at any time.'
  }
});

var consentPath = function consentPath(countryCode) {
  return countryCode ? "consent-account-creation-".concat(countryCode) : '';
};

export function logError(error) {
  var errorObj = isObject(error) ? error : {
    message: error
  };

  if (errorObj.httpStatus !== 404) {
    logger.error(errorObj.message);
  }
}
export function loadAccountCreationConsentForDetectedLocation(client) {
  var countryCode;
  return regeneratorRuntime.wrap(function loadAccountCreationConsentForDetectedLocation$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.prev = 0;
          _context.next = 3;
          return select(selectCountry);

        case 3:
          countryCode = _context.sent;
          _context.t0 = countryCode;

          if (!_context.t0) {
            _context.next = 9;
            break;
          }

          _context.next = 8;
          return call(fetchEntityIfNeeded, cmsLegalContent, [client, consentPath(countryCode)]);

        case 8:
          _context.t0 = _context.sent;

        case 9:
          return _context.abrupt("return", _context.t0);

        case 12:
          _context.prev = 12;
          _context.t1 = _context["catch"](0);
          _context.next = 16;
          return call(logError, _context.t1);

        case 16:
        case "end":
          return _context.stop();
      }
    }
  }, _marked, null, [[0, 12]]);
}
export function loadAccountCreationConsentForSelectedLocation(client) {
  var msa, countryCode;
  return regeneratorRuntime.wrap(function loadAccountCreationConsentForSelectedLocation$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          _context2.prev = 0;
          _context2.next = 3;
          return call(getMsa, client);

        case 3:
          msa = _context2.sent;
          countryCode = deepExtract('country.code', msa) || deepExtract('country_code', msa);
          _context2.t0 = countryCode;

          if (!_context2.t0) {
            _context2.next = 10;
            break;
          }

          _context2.next = 9;
          return call(fetchEntityIfNeeded, cmsLegalContent, [client, consentPath(countryCode)]);

        case 9:
          _context2.t0 = _context2.sent;

        case 10:
          return _context2.abrupt("return", _context2.t0);

        case 13:
          _context2.prev = 13;
          _context2.t1 = _context2["catch"](0);
          _context2.next = 17;
          return call(logError, _context2.t1);

        case 17:
        case "end":
          return _context2.stop();
      }
    }
  }, _marked2, null, [[0, 13]]);
}
export function loadAccountCreationConsentDefaults() {
  // TODO: Apply proper internationalization
  return {
    accountDisclaimer: messages.accountDisclaimer.defaultMessage,
    facebookDisclaimer: messages.facebookDisclaimer.defaultMessage,
    marketing: false,
    marketingDisclaimer: messages.marketingDisclaimer.defaultMessage,
    searchable: true,
    searchableDisclaimer: messages.searchableDisclaimer.defaultMessage,
    terms: messages.accountDisclaimer.defaultMessage
  };
}
export function loadAccountCreationConsent(client) {
  var consent;
  return regeneratorRuntime.wrap(function loadAccountCreationConsent$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          _context3.next = 2;
          return call(loadAccountCreationConsentForDetectedLocation, client);

        case 2:
          _context3.t1 = _context3.sent;

          if (_context3.t1) {
            _context3.next = 7;
            break;
          }

          _context3.next = 6;
          return call(loadAccountCreationConsentForSelectedLocation, client);

        case 6:
          _context3.t1 = _context3.sent;

        case 7:
          _context3.t0 = _context3.t1;

          if (_context3.t0) {
            _context3.next = 12;
            break;
          }

          _context3.next = 11;
          return all([call(loadAccountCreationConsentDefaults), call(logger.warn, 'Falling back to default consents')]);

        case 11:
          _context3.t0 = _context3.sent[0];

        case 12:
          consent = _context3.t0;
          return _context3.abrupt("return", _objectSpread({
            // Actual terms depends on signup form context (facebook/email/etc)
            // NOTE: don't override the disclaimer if the server starts returning one
            accountDisclaimer: consent.terms
          }, consent, {
            marketingDefault: consent.marketing,
            searchableDefault: consent.searchable
          }));

        case 14:
        case "end":
          return _context3.stop();
      }
    }
  }, _marked3);
}

function transformActionCheckbox(defaultState) {
  return {
    form_type: 'checkbox',
    form_default: defaultState ? 'checked' : 'unchecked'
  };
}

function transformActionSubmit() {
  return {
    form_type: 'submit'
  };
} // NOTE: Recording consent is a bit tricky.  Ideally, we only want to record
// decisions and would like to abstain from recording implied permissions if
// possbile (times when we assert consent through the terms).  Unfortunately,
// our system currently doesn't know how to distinguish between feature toggles
// and consent. Thus, we're in 1 of 2 cases:
// 1. The permission is covered by the terms language: the user consented by clicking submit
// 2. The permission has its own disclaimer: the user may consent through a toggle.
//    If so, then we need to know the toggle language and its default state as well.


export function transformConsentForApi() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      marketing = _ref.marketing,
      marketingDefault = _ref.marketingDefault,
      marketingDisclaimer = _ref.marketingDisclaimer,
      searchable = _ref.searchable,
      searchableDefault = _ref.searchableDefault,
      searchableDisclaimer = _ref.searchableDisclaimer,
      terms = _ref.terms;

  return [{
    action: transformActionSubmit(),
    consent_type: ['terms_of_use', 'privacy_policy'],
    is_granted: true,
    legal_copy: terms
  }, marketingDisclaimer ? {
    action: transformActionCheckbox(marketingDefault),
    consent_type: ['marketing_emails'],
    is_granted: !!marketing,
    legal_copy: marketingDisclaimer
  } : {
    action: transformActionSubmit(),
    consent_type: ['marketing_emails'],
    is_granted: true,
    legal_copy: terms
  }, searchableDisclaimer ? {
    action: transformActionCheckbox(searchableDefault),
    consent_type: ['social_search'],
    is_granted: !!searchable,
    legal_copy: searchableDisclaimer
  } : {
    action: transformActionSubmit(),
    consent_type: ['social_search'],
    is_granted: true,
    legal_copy: terms
  }];
}